// React
import React, { useContext, useEffect } from "react";

// React router
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
  Redirect,
} from "react-router-dom";

// HOC
import ProtectedRoute from "../components/ProtectedRoute";

// Components
import { SideMenu, MainContent, TopBar, MainContainer, SuperTopBar } from "./components";
import { NoMatch, Version } from "../components";

// Views
import {
  AllPositions,
  Position,
  Superadmin,
  Administration,
  Frontpage,
  Settings
} from "./views";
import PageView from "./views/Cp/PageView/PageView";
import { ACCESS_LEVEL, routeAccessChecker } from "./routeAccess";

// State management
import { StateUserContext } from "../context/UserContext";
import {
  getGenericLocalStorage,
  setGenericLocalStorage,
} from "../utils/localSave";

const Admin = () => {
  const { user } = useContext(StateUserContext);
  const hasRouteAccess = routeAccessChecker(user?.role);

  //key go back history saves
  let location = useLocation();
  useEffect(() => {
    const { pathname } = location;
    if (
      pathname.includes("/position/") ||
      pathname.includes("candidate/all") ||
      pathname === "/"
    ) {
      //save to key back location
      let currentAdminSettings = {};
      if (getGenericLocalStorage("admin_settings")) {
        currentAdminSettings = getGenericLocalStorage("admin_settings", true);
      }
      setGenericLocalStorage(
        "admin_settings",
        { ...currentAdminSettings, keyBackLocation: location.pathname },
        true
      );
    }
  }, [location]);

  return (
    <MainContainer>
      <SuperTopBar />
      <SideMenu />
      <MainContent>
        <TopBar />
        <Router>
          <Switch>
            <ProtectedRoute exact path="/" component={Frontpage} />
            <ProtectedRoute path="/success" component={AllPositions} />
            <ProtectedRoute path="/settings" component={Settings} />

            {/* Positions */}
            <ProtectedRoute exact path="/position" component={AllPositions} />
            <ProtectedRoute exact path="/position/:id" component={Position} />

            {/* Career Pages */}
            {hasRouteAccess(ACCESS_LEVEL.owner) ? (
              <ProtectedRoute path="/cp/site/:language" component={PageView} />
            ) : (
              <Route path="/cp/site/:language" render={() => <Redirect to="/" />} />
            )}

            {/* Administration */}
            {hasRouteAccess(ACCESS_LEVEL.owner) ? (
              <ProtectedRoute exact path="/administration" component={Administration} />
            ) : (
              <Route path="/administration" render={() => <Redirect to="/" />} />
            )}

            {/* Superadmin */}
            {hasRouteAccess(ACCESS_LEVEL.super) ? (
              <ProtectedRoute exact path="/superadmin" component={Superadmin} />
            ) : (
              <Route path="/superadmin" render={() => <Redirect to="/" />} />
            )}
            <Route component={NoMatch} />
          </Switch>
        </Router>
        <Version />
      </MainContent>
    </MainContainer>
  );
};

export default Admin;
